import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
	async getCompanyShortName(input) {
		try {
			let result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'external/getCargoClientList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getapprovalLog(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/getapprovalog',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getApprovalLogAgainObjectID(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/getapprovallogagainobjectid',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getActiveInactiveClientList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/cargoclientkyc/getactiveinactiveclient',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/reporting/services/reporting.service.js